<div mat-dialog-data class="content-block">

    <!-- <p>Submitted Successfully</p> -->
    <img src="../../assets/gif/tick.gif" alt="" style="width:100%;">
    <p>Form Submitted Successfully</p>
    <br>
    <button type="button" class="theme-btn" style="margin:auto;display:block;" mat-dialog-close>Done</button>

</div>